import 'datatables.net-dt/css/jquery.dataTables.css'
import 'datatables.net-buttons-dt/css/buttons.dataTables.css'
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import Moment from 'react-moment';
import React, {Component} from 'react';
import {translate} from 'react-i18next';
import swal from 'sweetalert';
import moment from 'moment';
import Help from '../generics/help';
import LabelForm from '../../components/LabelForm';
import SelectForm from '../../components/SelectForm';
import { clinicHistoryYearsHasHc, donationTypeExtraction, labSectionsByHf, pdfIMSS } from '../../libs/services';
import { Table } from 'react-bootstrap';

const $ = require('jquery');
$.DataTable = require('datatables.net-dt');

require('datatables.net-buttons/js/dataTables.buttons.min' );

pdfMake.vfs = pdfFonts.pdfMake.vfs;

const jzip = require( 'jszip');
require( 'datatables.net-buttons/js/buttons.html5.min' );
window.JSZip = jzip;

var session = sessionStorage.getItem('health_facilities_name');
var Config = require('../../config');

class InformationCrossing extends Component{
	constructor(props){
		super(props);

		this.handleChange = this.handleChange.bind(this);
		this.searching = this.searching.bind(this);
		this.isValidForm = this.isValidForm.bind(this);
		this.showCtrlError = this.showCtrlError.bind(this);
		this.dateCompare = this.dateCompare.bind(this);

		this.setTable = this.setTable.bind(this);
        this.onPrint = this.onPrint.bind(this);

		this.state = {
            year:'',
            init_month:'',            
            years:[],
            months:[
                {value:'1', text:'Enero'},
                {value:'2', text:'Febrero'},
                {value:'3', text:'Marzo'},
                {value:'4', text:'Abril'},
                {value:'5', text:'Mayo'},
                {value:'6', text:'Junio'},
                {value:'7', text:'Julio'},
                {value:'8', text:'Agosto'},
                {value:'9', text:'Septiembre'},
                {value:'10', text:'Octubre'},
                {value:'11', text:'Noviembre'},
                {value:'12', text:'Diciembre'},
            ],
			listado:[],
            columns:[[
				{title:'Día', width:'50px'},
                {title:'', width:'40px'},
				{title:'Unidad', width:'60px'},
                {title:'Unidad', width:'60px'},
                {title:'Total', width:'60px'},
                {title:'UNID.', width:'50px'},
                {title:'No.', width:'50px'},
                {title:'No.', width:'50px'},
                {title:'CAN', width:'50px'},
                {title:'CTH', width:'50px'},
                {title:'CTH', width:'50px'},
                {title:'CTH', width:'50px'},
                {title:'PLAS', width:'50px'},
                {title:'PLAS', width:'50px'},
                {title:'PD', width:'50px'},
                {title:'PD', width:'50px'},
                {title:'PD', width:'50px'},
                {title:'ERIT', width:'80px'},
                {title:'ERIT', width:'80px'},
                {title:'ERIT', width:'70px'},
                {title:'LEU', width:'50px'},
                {title:'COR', width:'50px'},
                {title:'CAN', width:'50px'},
                {title:'CAN', width:'50px'},
                {title:'ALT', width:'50px'},
                {title:'ALT', width:'50px'},
                {title:'TOTALES', width:'80px'},
			],[
				{title:'', width:'50px'},
                {title:'', width:'40px'},
				{title:'Empezó', width:'60px'},
                {title:'Terminado', width:'60px'},
                {title:'', width:'60px'},
                {title:'EXT.', width:'50px'},
                {title:'INT.', width:'50px'},
                {title:'AF.', width:'50px'},
                {title:'AF', width:'50px'},
                {title:'INT', width:'50px'},
                {title:'EXT', width:'50px'},
                {title:'CAN', width:'50px'},
                {title:'INT', width:'50px'},
                {title:'EXT', width:'50px'},
                {title:'INT', width:'50px'},
                {title:'EXT', width:'50px'},
                {title:'CAN', width:'50px'},
                {title:'Sencillos', width:'80px'},
                {title:'Dobles', width:'80px'},
                {title:'CAN', width:'50px'},
                {title:'INT', width:'50px'},
                {title:'DON', width:'50px'},
                {title:'INT', width:'50px'},
                {title:'EXT', width:'50px'},
                {title:'INT', width:'50px'},
                {title:'CAN', width:'50px'},
                {title:'', width:'80px'},
			]],
            totals:'',
			filename:"Cruce de Información",
            start_date:"",
            end_date:""
		}
	}

	componentWillMount(){
		if(!this.props.hiddeToReport){
			this.props.reload();
		}

	}

	async componentDidMount(){
        var id = sessionStorage.getItem('health_facilities_id');
        var options = [];

        var response = await clinicHistoryYearsHasHc(id);
        if(response){
            options = response.map((res)=>{
                var obj = {
                    value: res,
                    text:res
                };

                return obj;
            });

            this.setState({years: options});
        }

		await this.setTable();
	}

	setTable(){
		this.$el = $(this.el);

        var obj = {
			year: this.state.year,
			init_month: this.state.init_month,
        };

		var table = this.$el.DataTable({
			dom: 'Bfrtip',
			buttons: [                
				{
                	extend: 'excelHtml5',
                	title: this.state.filename,
                	action: (e, dt, node, config)=>{
                        this.props.printExcelReport(this.state.filename, 'information_crossing', obj);
                    }
            	},
                {
                    text:'PDF',
                    action: (e, dt, node, config)=>{
                        this.props.printPdfIMSSReports('information_crossing', obj);
                    }
                }
            ],
			data: this.state.listado,
			//columns:this.state.columns,			
			oLanguage:{
				"sProcessing":"Procesando...",
				"sZeroRecords":"No se encontraron resultados",
				"sEmptyTable":"Ningún dato disponible en esta tabla",
				"sInfoEmpty":"Mostrando registros del 0 al 0 de un total de 0 registros",
				"sInfoPostFix":"",
				"sSearch":"Buscar:",
				"sUrl":"",
				"sInfoThousands":",",
				"sLoadingRecords":"Cargando...",
			},
			paging:false,
			ordering:false,
			responsive:true,
			searching: false,
			scrollY:"32em",
			scrollX: true,
			autoWidth: false,
			info:false,
            createdRow: (row, data, dataIndex)=>{
                if(data[0] === ''){
                    data.forEach((d, i)=>{
                        $('td:eq('+i+')', row).attr('style', 'font-weight: bold;background:#dadada;');
                    })
                }
				

			}	
		});

		if (table.rows().indexes().length === 0 ) {
			table.buttons('.dt-button').disable();
		}else {
			table.buttons('.dt-button').enable();
		}
	}

	handleChange(e){
		
		this.setState({
			[e.target.name]: e.target.value
		});

        setTimeout(()=>{
			if(this.state.year !== "" && this.state.init_month !== ""){
				let value = parseInt(this.state.init_month);
				let month = value < 10 ? '0'+(value) : value;
				let nextMonth = value < 10 ? '0'+(value+1) :  value === 12 ? '01' : value + 1;
				let nextYear = value === 12 ? parseInt(this.state.year) + 1 : this.state.year;
				this.setState({
					start_date: this.state.year+'-'+month+'-'+26,
					end_date: nextYear+'-'+nextMonth+'-'+25,
				});			
			}
		}, 500);
		
		if(document.getElementById(e.target.name).className.includes('error')){
			document.getElementById(e.target.name).classList.remove('error');
		}
	}

	searching(){

		if(this.isValidForm()){
			if(this.dateCompare()){
				var obj = {
					year: this.state.year,
                    init_month: this.state.init_month,
				}
				
                this.props.waiting.handleShow('Buscando...');
                fetch(Config.default.apiGateway.URL+'reports_imss/information_crossing',{
                    method: 'POST',
                    body:JSON.stringify(obj),
                    headers: new Headers({
                        'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
                        'Accept'		: 'application/json',
                        'Content-Type'	: 'application/json'
                    })
                }).then(res => {
                    this.props.waiting.handleClose();

                    if(res.ok){
                        return res.json();
                    }else{
                        res.text().then((msg)=>{
                            swal('Error', msg, 'error');
                        });
                    }
                }).then(async response => {
                    if(response !== undefined){
                        var list = [];

						response.weeks.forEach((weeks)=>{
                            weeks.daily_results.forEach((week)=>{
                                list.push([
                                    week.day_name,
                                    week.day,
                                    week.start_folio,
                                    week.end_folio,
                                    week.total_donations,
                                    week.units_convoke_places,
                                    week.units_center,
                                    week.units_pqaf_simple,
                                    week.donations_af_cancel,
                                    week.units_cell_center,
                                    week.units_cell_external,
                                    week.donations_cell_cancel,
                                    week.units_plaf_center,
                                    week.units_plaf_external,
                                    week.units_pqaf_double_center,
                                    week.units_pqaf_double_external,
                                    week.donations_pqaf_double_cancel,
                                    week.units_eraf_simple,
                                    week.units_eraf_double,
                                    week.donations_eraf_cancel,
                                    week.units_leuco_center,
                                    week.units_cordon,
                                    week.donations_st_center_cancel,
                                    week.donations_st_external_cancel,
                                    week.donations_alt_center,
                                    week.donations_alt_cancel,
                                    week.total,
                                ])
                            });

                            
                            list.push([
                                '',
                                '',
                                '',
                                '',
                                '',
                                weeks.totals.units_convoke_places,
                                weeks.totals.units_center,
                                weeks.totals.units_pqaf_simple,
                                weeks.totals.donations_af_cancel,
                                weeks.totals.units_cell_center,
                                weeks.totals.units_cell_external,
                                weeks.totals.donations_cell_cancel,
                                weeks.totals.units_plaf_center,
                                weeks.totals.units_plaf_external,
                                weeks.totals.units_pqaf_double_center,
                                weeks.totals.units_pqaf_double_external,
                                weeks.totals.donations_pqaf_double_cancel,
                                weeks.totals.units_eraf_simple,
                                weeks.totals.units_eraf_double,
                                weeks.totals.donations_eraf_cancel,
                                weeks.totals.units_leuco_center,
                                weeks.totals.units_cordon,
                                weeks.totals.donations_st_center_cancel,
                                weeks.totals.donations_st_external_cancel,
                                weeks.totals.donations_alt_center,
                                weeks.totals.donations_alt_cancel,
                                weeks.totals.total,
                            ])
                            
                            
                        })

						setTimeout(()=>{
							this.props.waiting.handleShow('Cargando...');
							this.$el = $(this.el);
							this.$el.DataTable().destroy();

                            this.setState({
                                listado: list,
								totals: response.totals
                            });
                            
						}, 1000);

						setTimeout(()=>{
							this.props.waiting.handleClose();
							this.setTable();
						}, 1500);
                    }
                });
               
			}else{
				swal('Error', 'La Fecha Hasta debe ser mayor o igual a Fecha Desde', 'error');
			}
			
		}else{
			swal('Error', 'Campos Incompletos', 'error');
		}
	}

	dateCompare(){
		var ini = moment(this.state.start_date);
		var fin = moment(this.state.end_date);
		var date_ok = true;
		if(this.state.search_type === 'date'){
			if(ini !== 'Invalid date' && fin !== 'Invalid date'){
				if(fin < ini){
					date_ok = false;
					document.getElementById('end_date').classList.add('error');
				}else{
					document.getElementById('end_date').classList.remove('error');
				}
			}else{
				date_ok = false;
			}		
		}
		
		return date_ok;
	}

	isValidForm() {
		const select = document.querySelector('form');
		const inputs = select.querySelectorAll('input, select');
	    let isFormValid = true;
	    
	    inputs.forEach(input => {
	    	if(input.required){
	    		
		      	const isInputValid = this.showCtrlError(input.name);
		      	if (!isInputValid) {
		        	isFormValid = false;
		    	}
		    	
		   
		  	}
	    });	    

	    return isFormValid;
	}

	showCtrlError(refName) {
		var res = null;
		var control = document.getElementById(refName);
		if (this.state[refName] === "") {

			if(control !== null){
				control.classList.add('error');
			}
			res = false;
		} else{
			if(control !== null){
				if(control.required && control.className.includes('error')){
					control.classList.remove('error');
				}
			}
			res = true;
		}
		

		return res;
	}

    onPrint(type){
        var obj = {
            health_facilities_id: this.state.health_facilities_id,
            year: this.state.year,
            init_month: this.state.init_month,
        }

        if(type === 'excel'){
            this.props.printExcelReport(this.state.filename, 'information_crossing', obj);
        }else{
            this.props.printPdfIMSSReports('information_crossing', obj);
        }
    }

	render(){
		const {t} = this.props;

		return (
			<div className="col-xs-12">
				<div className="route">
					<h5 className="title_page">
					{session} ->
					{t('sidebar.nav.reports.MAIN')} ->
					{this.state.filename}
					</h5>
				</div>
				<Help 
					{...this.props}
		            menu={"help_imss"} 
		            submenu={"help_information_crossing"}  />

				<div className="form-group" style={{paddingLeft:"0.5em"}}>
					<div className="col-xs-12">
						<form noValidate>
							<div className="col-xs-12 col-sm-2" style={{borderRight:"1px solid #e0e0e0"}}>												
                                <div className="form-group">
                                    <LabelForm text="Años" />
                                    <SelectForm 
                                        id="year"
                                        value={this.state.year}
                                        options={this.state.years}
                                        handleChange={this.handleChange}
                                        required
                                    />
                                </div>
                                <div className="form-group">
                                    <LabelForm text="Mes" />
                                    <SelectForm 
                                        id="init_month"
                                        value={this.state.init_month}
                                        options={this.state.months}
                                        handleChange={this.handleChange}
                                        required
                                    />
                                </div>

							
								<div style={{textAlign:"right"}}>
									<button type="button" className="btn btn-info" onClick={this.searching} style={{fontSize:"1em"}}>
										Buscar
									</button>
								</div>
							</div>

							<div className="col-xs-12 col-sm-10">
								<div className="col-xs-12">
									<div className="col-xs-12" style={{marginTop:"20px",textAlign: "center",fontWeight: "bold",textDecoration: "underline",fontSize:'16px'}}>
										<span>
											{this.state.filename}
										</span>
									</div>
									
                                    <div className="col-xs-12" >
										<span>
											Información Del:  {this.state.start_date !== "" ?
												moment(this.state.start_date).format("DD/MM/YYYY")
											: ''}    
										</span>
										<span style={{marginLeft:"5px"}}>	
											Al: {this.state.end_date !== "" ?
												moment(this.state.end_date).format("DD/MM/YYYY")
											: ''}
										</span>
									</div>
								</div>

                                {/*<div className="col-xs-12 form-group" style={{textAlign:'right'}}>
									<button type="button" className="btn btn-default" disabled={this.state.listado.length === 0} onClick={(e) => this.onPrint('excel')} style={{marginRight:8}}>Excel</button>
									<button type="button" className="btn btn-default" disabled={this.state.listado.length === 0} onClick={(e) => this.onPrint('pdf')}>PDF</button>
								</div>*/}
								<div className="col-xs-12 form-group" id="table-to-pdf">									
									<div className="table-responsive">
										<table style={{fontSize:"11px"}} className="expenses-discards" id="table-to-xls" 
											 ref={el => this.el = el}>
                                            <thead>
                                                {this.state.columns.map((columns, i)=>
                                                    <tr key={i}>
                                                        {columns.map((col, j)=>
                                                            <th key={j} style={{width:col.width}}>
                                                                {col.title}
                                                            </th>
                                                        )}
                                                    </tr>
                                                )}
                                            </thead>
										</table>
									</div>
									
								</div>			
                                <div className='col-xs-12 form-group'>
									
                                    {this.state.totals !== '' &&
                                        <>                                                    
                                            
                                            <span style={{display:'block'}}>UNID - EXT. {': '+this.state.totals.units_convoke_places}</span>
                                            <span style={{display:'block'}}>No. INT. {': '+this.state.totals.units_center}</span>
                                            <span style={{display:'block'}}>No. AF. {': '+this.state.totals.units_pqaf_simple}</span>
                                            <span style={{display:'block'}}>CAN - AF {': '+this.state.totals.donations_af_cancel}</span>
                                            <span style={{display:'block'}}>CTH - INT {': '+this.state.totals.units_cell_center}</span>
                                            <span style={{display:'block'}}>CTH - EXT {': '+this.state.totals.units_cell_external}</span>
                                            <span style={{display:'block'}}>CTH - CAN {': '+this.state.totals.donations_cell_cancel}</span>
                                            <span style={{display:'block'}}>PLAS - INT {': '+this.state.totals.units_plaf_center}</span>
                                            <span style={{display:'block'}}>PLAS - EXT {': '+this.state.totals.units_plaf_external}</span>
                                            <span style={{display:'block'}}>PD - INT {': '+this.state.totals.units_pqaf_double_center}</span>
                                            <span style={{display:'block'}}>PD - EXT {': '+this.state.totals.units_pqaf_double_external}</span>
                                            <span style={{display:'block'}}>PD - CAN {': '+this.state.totals.donations_pqaf_double_cancel}</span>
                                            <span style={{display:'block'}}>ERIT - Sencillos {': '+this.state.totals.units_eraf_simple}</span>
                                            <span style={{display:'block'}}>ERIT - Dobles {': '+this.state.totals.units_eraf_double}</span>
                                            <span style={{display:'block'}}>ERIT - CAN {': '+this.state.totals.donations_eraf_cancel}</span>
                                            <span style={{display:'block'}}>LEU - INT {': '+this.state.totals.units_leuco_center}</span>
                                            <span style={{display:'block'}}>COR - DON {': '+this.state.totals.units_cordon}</span>
                                            <span style={{display:'block'}}>CAN - INT {': '+this.state.totals.donations_st_center_cancel}</span>
                                            <span style={{display:'block'}}>CAN - EXT {': '+this.state.totals.donations_st_external_cancel}</span>
                                            <span style={{display:'block'}}>ALT - INT {': '+this.state.totals.donations_alt_center}</span>
                                            <span style={{display:'block'}}>ALT - CAN {': '+this.state.totals.donations_alt_cancel}</span>                                            
                                            <span style={{display:'block'}}>TOTALES {': '+this.state.totals.total}</span>
                                                                                        
                                        </>
                                    }
								</div>					
							</div>
						</form>
					</div>
				</div>
			</div>
		)
	}
}

export default translate('translations') (InformationCrossing);